const Login = () => import('@/views/authentication/Login.vue')
const SignUp = () => import('@/views/authentication/SignUp.vue')
// const SocialSignUp = () => import('@/views/authentication/SocialSignUp.vue')
const ForgottenPassword
 = () => import('@/views/authentication/ForgottenPassword.vue')
const SetNewPassword = () => import('@/views/authentication/SetNewPassword.vue')
const ConfirmSetupOTP = () => import('@/views/authentication/ConfirmSetupOTP.vue')
const ConfirmResetOTP = () => import('@/views/authentication/ConfirmResetOTP.vue')

const ValidateResetLink = () => import('@/views/authentication/ValidateResetLink.vue')
import store from '@/store'


export default
  [
    {
      path: 'login',
      component: Login,
      name: "login"
    },
    {
      path: 'confirm-email',
      name: "confirm-email",
      component: ForgottenPassword

      //TODO: add middleware, only user in reset password can enter this route
    },
    {
      path: 'reset-password',
      name: "reset-password",
      component: SetNewPassword
      //TODO: add middleware, only user in reset password can enter this route
    },
    {
      path: 'sign-up',
      name: 'email-sign-up',
      component: SignUp
    },
    /*  {
       path: 'sign-up/social',
       name: 'social-sign-up',
       component: SocialSignUp
     }, */
    {
      /**
       * the confirm otp screen will be used to  confirm account setup and and password reset
       * if a user does not have access token, they will be redirected to the login page and a toast should be fired
       */
      name: 'confirm-setup-otp',
      path: 'sign-up/verify-otp',
      component: ConfirmSetupOTP,
      beforeEnter: (from, to, next) => {
        if (!store.getters["auth/otp_permission"]) {
          return next({
            name: "login"
          })
        }
        next()
      },
    },


    {
      /**
       * the confirm otp screen will be used to  confirm account setup and and password reset
       * if a user does not have access token, they will be redirected to the login page and a toast should be fired
       */
      name: 'confirm-reset-otp',
      path: 'reset-password/confirm-otp',
      component: ConfirmResetOTP,
      beforeEnter: (from, to, next) => {
        if (!store.getters["auth/otp_permission"]) {
          return next({
            name: "login"
          })
        }
        next()
      },
    },
    {
      //use to confirm account setup and and password reset
      name: 'validate-token',
      path: 'validate-token/:token',
      component: ValidateResetLink
    }
  ]

